// extracted by mini-css-extract-plugin
module.exports = {"redButton":"styles_redButton__1K9or","ant-btn-primary":"styles_ant-btn-primary__FUg69","reasonSelect":"styles_reasonSelect__3KqV7"};